import {  HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from 'app/core/auth/auth.service';
import { AuthUtils } from 'app/core/auth/auth.utils';
import { catchError, Observable, throwError } from 'rxjs';
/**
* Intercept
*
* @param req
* @param next
*/
export const authInterceptor = (req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> =>
{
    // Skip interceptor for asset files (JSON, CSS, images, etc.)
    // These should be loaded without authentication headers
    const url = req.url;
    const isAssetRequest =
        url.includes('/assets/') ||
        url.endsWith('.json') ||
        url.endsWith('.css') ||
        url.endsWith('.js') ||
        url.endsWith('.png') ||
        url.endsWith('.jpg') ||
        url.endsWith('.jpeg') ||
        url.endsWith('.gif') ||
        url.endsWith('.svg') ||
        url.endsWith('.woff') ||
        url.endsWith('.woff2') ||
        url.endsWith('.ttf') ||
        url.endsWith('.eot') ||
        url.startsWith('./assets/') ||
        url.startsWith('/assets/');
    // If it's an asset request, skip all interceptor logic
    if (isAssetRequest) {
        return next(req);
    }
    const authService = inject(AuthService);
    // Clone the request object
    let newReq = req.clone();
    // Request
    //
    // If the access token didn't expire, add the Authorization header.
    // We won't add the Authorization header if the access token expired.
    // This will force the server to return a "401 Unauthorized" response
    // for the protected API routes which our response interceptor will
    // catch and delete the access token from the local storage while logging
    // the user out from the app.
    if ( authService.accessToken && !AuthUtils.isTokenExpired(authService.accessToken) )
    {
        newReq = req.clone({
            headers: req.headers.set('Authorization', 'Bearer ' + authService.accessToken),
        });
    }
    // Response
    return next(newReq).pipe(
        catchError((error) =>
        {
             return throwError(() => error);
        }),
    );
};
